import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20f65222"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "box_tar_item_position"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "box_tar_item_normal"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { ref, reactive, watch, nextTick, onMounted } from 'vue'
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from "vuex"
    import { MenuVerification } from '@/interface'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore()

    let datas = ref<string[]>([])

    const openCode = ref<boolean>(false)

    const route = useRoute()

    const router = useRouter()

    const Menu = reactive<Array<MenuVerification>>([
        {
            icon: require('@/assets/icon/nav_daiban@2x.png'),
            activeIcom: require('@/assets/icon/nav_daiban_sel@2x.png'),
            path: '/index',
            isActive: false,
            name: '待办'
        },
        {
            icon: require('@/assets/icon/nav_gongzuotai@2x.png'),
            activeIcom: require('@/assets/icon/nav_gongzuotai_sel@2x.png'),
            path: '/workbench',
            isActive: false,
            name: '工作台'
        },
        // {
        //     icon: require('@/assets/icon/nav_saoma@2x.png'),
        //     activeIcom: require('@/assets/icon/nav_saoma@2x.png'),
        //     path: '',
        //     isActive: false,
        //     isCode: true,
        //     name: '扫码'
        // },
        // {
        //     icon: require('@/assets/icon/nav_kanban@2x.png'),
        //     activeIcom: require('@/assets/icon/nav_kanban_sel@2x.png'),
        //     path: '/bulletinboard',
        //     isActive: false,
        //     name: '看板'
        // },
        {
            icon: require('@/assets/icon/nav_wode@2x.png'),
            activeIcom: require('@/assets/icon/nav_wode_sel@2x.png'),
            path: '/my',
            isActive: false,
            name: '我的'
        }
    ])

    const jump = (path: string): void => {
        if (path === '') {
            openCode.value = true
            return
        }
        router.push({ path })
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 获取扫码值
    const onDecode = (data: string[]): void => {
        console.log(data)
        datas.value = data
        nextTick(() => {
            openCode.value = false
        })
    }

    // 监听函数
    watch(() => route.path,(news, old): void => {
        Menu.forEach(item => {
            item.isActive = item.path === news;
        })
    },{ immediate: true })

    onMounted(() =>{
        store.dispatch('getUpcomingNum')
    })

return (_ctx: any,_cache: any) => {
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "box_h",
      style: _normalizeStyle([{"height":"49px"}, _unref(store).state.type ? 'padding-bottom: 15px;' : ''])
    }, null, 4),
    _createElementVNode("div", {
      class: "box_tar",
      style: _normalizeStyle([{"height":"49px"}, _unref(store).state.type ? 'padding-bottom: 15px;' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Menu), (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "box_tar_item",
          key: i,
          onClick: _withModifiers(($event: any) => (jump(item.path)), ["stop"])
        }, [
          (item.isCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "box_tar_item_code",
                  src: item.isActive ? item.activeIcom : item.icon,
                  alt: ""
                }, null, 8, _hoisted_4),
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: item.isActive ? '#222222' : '#666666' })
                }, _toDisplayString(item.name), 5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (item.path === '/index' && _unref(store).state.upcomingNum.d > 0)
                  ? (_openBlock(), _createBlock(_component_van_badge, {
                      key: 0,
                      content: _unref(store).state.upcomingNum.d,
                      max: "99"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.isActive ? item.activeIcom : item.icon,
                          alt: ""
                        }, null, 8, _hoisted_6)
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: item.isActive ? item.activeIcom : item.icon,
                      alt: ""
                    }, null, 8, _hoisted_7)),
                _createElementVNode("span", {
                  style: _normalizeStyle({ color: item.isActive ? '#222222' : '#666666' })
                }, _toDisplayString(item.name), 5)
              ]))
        ], 8, _hoisted_2))
      }), 128))
    ], 4),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['第一次扫码', '第二次扫码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"])
  ]))
}
}

})